// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1776542567200
      var cssReload = require("/Users/markslawton/Desktop/Root/FutbolWorld/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  